// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopularItem_wrapper__1qNY-","image":"PopularItem_image__1N8sZ","title":"PopularItem_title__3WtKr","date":"PopularItem_date__3J-cE"};